import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useSMLCountryParam } from './useSMLCountryParam';
import { useSMLGenreParam } from './useSMLGenreParam';

interface UseArtistsTopOverallProps {
  page: number;
  limit?: number;
  date?: Date;
}

export const useArtistsTopOverall = ({ page, limit = 10, date }: UseArtistsTopOverallProps) => {
  const trpcMusicAPI = useTRPCAPI();
  const { countryCode } = useSMLCountryParam();
  const { genre } = useSMLGenreParam();
  const offset = (page - 1) * limit;

  const artistsQuery = useTRPCQuery(
    trpcMusicAPI.artists.topOverall.queryOptions({
      offset,
      limit,
      date: date ?? undefined,
      countryCode,
      genre,
    })
  );

  return artistsQuery;
};
